import { createAction } from 'redux-actions'
export default createAction('combinations/ERROR')
